import Api from "../apiService";

class suggestionsApi {
  address(params) {
    return Api.getRequest(
      "external/suggestions/address",
      { query: params },
      Api.authHeaders()
    );
  }

  geolocate(lat, lon) {
    return Api.getRequest(
      "external/suggestions/address",
      { lat, lon },
      Api.authHeaders()
    );
  }

  party(params) {
    return Api.getRequest(
      "external/suggestions/party",
      { query: params },
      Api.authHeaders()
    );
  }

  bank(params) {
    return Api.getRequest(
      "external/suggestions/bank",
      { query: params },
      Api.authHeaders()
    );
  }
}

export default new suggestionsApi();
